import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
  configApiRef,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';

const scmIntegrationsApi =
  ApiBlueprint.make({
    params: defineParams =>
      defineParams({
        api: scmIntegrationsApiRef,
        deps: { configApi: configApiRef },
        factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi)
      }),
  });

export const apis = [
  scmIntegrationsApi,
];
